var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYhand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 90,
    viewBox: "0 0 78 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.9051 24.3184C47.4645 24.3184 45.4699 21.4922 44.2509 20.6057C43.0319 19.7192 41.8679 18.8326 40.7048 17.392C39.5417 15.9514 38.5435 13.8459 37.2137 11.408C35.8839 8.97007 36.2722 7.25198 34.4991 3.42929C32.7261 -0.393395 30.1224 1.10217 30.0116 2.48781C29.9007 3.87344 30.6215 4.03922 30.6765 6.53213C30.7314 9.02503 31.1197 10.2449 31.2864 10.5764C31.4531 10.908 32.4495 13.236 32.727 15.1757C33.0045 17.1154 33.2252 17.3371 33.8351 18.2786C34.4451 19.22 36.1623 22.7112 36.6614 24.3734C37.1596 26.0356 38.711 30.1908 39.1543 31.0773C39.5975 31.9638 39.8555 34.4523 39.8555 34.4523C40.2075 39.3885 42.9779 42.9895 44.3076 46.2032C45.6374 49.4168 46.6348 48.7519 46.4025 52.298C46.1702 55.8441 46.524 55.7333 46.4131 58.6145C46.3023 61.4957 47.078 80.9992 47.078 80.9992",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0732 18.862C42.0732 18.862 44.1388 18.3346 44.9704 17.3922C45.802 16.4498 46.7434 15.6191 48.4057 15.0651C50.0679 14.511 51.5635 13.6803 53.005 12.6821C54.4464 11.6839 55.2213 10.909 57.4376 11.2415C59.6539 11.5739 59.9863 14.1777 60.3737 15.9507C60.7612 17.7237 61.9801 23.0429 62.4792 24.5943C62.9775 26.1457 63.2549 28.1954 63.5874 29.4152C63.9198 30.6351 65.3604 34.2911 62.9775 35.3992C60.5945 36.5074 59.8746 34.2361 59.8197 33.9586",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1241 15.7857C50.1241 15.7857 53.2819 14.8442 54.5567 18.002C55.8315 21.1598 56.1631 22.8229 57.5487 25.15C58.9343 27.4771 58.7322 30.4319 59.3767 32.4638C60.0212 34.4957 60.6515 36.7298 58.601 37.4505C56.5505 38.1713 54.1675 35.7883 53.1985 31.7989L52.8386 30.3583C52.8386 30.3583 52.8386 29.9151 52.2845 29.3052C51.7305 28.6952 49.8466 25.5924 49.8466 25.5924C49.8466 25.5924 48.5718 23.7635 48.5718 21.8796",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1924 24.9275C45.1924 24.9275 47.3954 27.5481 50.0895 25.9887",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6553 11.7697C58.6553 11.7697 59.8751 9.91248 61.759 9.91248C63.6429 9.91248 65.4159 11.1873 65.97 13.6802C66.5241 16.1731 67.2998 21.2156 67.6322 22.2688C67.9647 23.322 70.1251 29.7493 66.4132 30.9124C66.4132 30.9124 64.118 31.8921 63.587 29.416",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7986 21.8246C67.7986 21.8246 68.2667 21.2146 68.5593 19.8299C68.8518 18.4451 68.9626 12.2395 72.4529 8.74834C75.9431 5.25721 77.717 7.86182 77.163 9.52405C76.6089 11.1863 76.553 14.6216 76.2215 15.9513C75.8899 17.2811 75.0025 19.3866 74.8917 22.212C74.7809 25.0373 75.6674 27.4761 74.0601 30.6898C72.4538 33.9034 72.2321 36.0089 71.2897 38.6135C70.3474 41.2181 68.8518 42.7137 67.4112 43.5444C65.9706 44.3751 66.0814 46.3148 66.0265 48.6419C65.9715 50.969 66.2481 66.2615 66.6914 69.3085C67.1346 72.3555 68.741 79.8918 68.741 81",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9805 67.375L30.8984 54.5625H37.3047L27.9688 72.6875V83H22.0117V72.6875L12.6758 54.5625H19.1016L24.9805 67.375Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2424 71.8929) rotate(88.0754) scale(45.1147 45.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYhand);
export default __webpack_public_path__ + "static/media/Yhand.ba38035c974d94099a97701f53226cf8.svg";
export { ForwardRef as ReactComponent };